import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { AbstractSandbox } from 'app/core/sandboxes/abstract.sandbox';
import { UsersFilter } from '../store/admin/users/users-filter.interface';
import { UserRestService } from '../services/rest/admin/user.rest.service';
import { util } from '../util/util';
import moment from 'moment';
import { ClientUsersDownloadStartAction, ClientUsersDownloadStopAction, EpsUsersDownloadStartAction, EpsUsersDownloadStopAction } from '../store/admin/users/users.actions';
import { AdminDefinition } from '../store/admin/admin-definitions/admin-definitions.interface';
import { CustomersRestService } from '../services/rest/customers.rest.service';

@Injectable({ providedIn: 'root' })
export class UsersSandbox extends AbstractSandbox {
  constructor(private userRestService: UserRestService, private customersRestService: CustomersRestService) {
    super();
  }

  epsUsersDownloading$ = this.store.select(state => state.admin.epsUsers.downloading);
  clientUsersDownloading$ = this.store.select(state => state.admin.clientUsers.downloading);

  downloadEpsUsers(filter: UsersFilter) {
    this.store.dispatch(new EpsUsersDownloadStartAction());
    this.downloadUsers(filter, 'EpsUser', new EpsUsersDownloadStopAction());
  }

  downloadClientUsers(filter: UsersFilter) {
    this.store.dispatch(new ClientUsersDownloadStartAction());
    this.downloadUsers(filter, 'ClientUser', new ClientUsersDownloadStopAction());
  }

  private downloadUsers(filter: UsersFilter, type: 'EpsUser' | 'ClientUser', stopAction: Action) {
    this.userRestService.downloadUsers({...filter, type }).subscribe((result: Blob) => {
      const timestamp = moment().format('YYYYMMDDHHmmss');
      util.openBlob(result, `${type}s-${timestamp}.xlsx`);
      this.store.dispatch(stopAction);
    });
  }

  async getSoldTos(salesOrganisationId: string): Promise<AdminDefinition[]> {
    if (!salesOrganisationId || salesOrganisationId === '') {
      return [];
    }
    const customers = await this.customersRestService.getSoldTosForSalesOrganisation(salesOrganisationId);
    return customers.items.map(customer => ({
      id: customer.customerNumber,
      name: customer.customerName
    }));
  }
}
